import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Col } from 'react-bootstrap';
import FormBusca from './form_busca';
import RHService from '../../../services/rh'
import Estagiario from './estagiario';

const ListarEstagiarios = () => {

    const [estagiarios, setEstagiarios] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [secretarias, setSecretarias] = useState([]);

    async function fetchEstagiarios() {
        await montaSelectSecretarias()
        const response = await RHService.listarEstagiarios();
        if (response.data.length >= 1) {
            setEstagiarios(response.data)
            setVazio(false)
        } else {
            setEstagiarios([])
            setVazio(true)
        }
    }

    const montaSelectSecretarias = async () => {
        const prod = await RHService.listarEstagiarios();
        setSecretarias(prod.data)
    }

    useEffect(() => {
        fetchEstagiarios();
    }, []);

    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setEstagiarios={setEstagiarios}
                    setVazio={setVazio}
                    secretarias={secretarias}
                    fetchEstagiarios={fetchEstagiarios}
                    estagiarios={estagiarios}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <h5>Estagiários em Macuco </h5>
                    <h6>Caso o nome do estagiário seja exibido apenas pelas suas iniciais, tratam-se de menores de idade que participam do projeto da Guarda Mirim Municipal.</h6>
                    <Row xs={3}>
                        {estagiarios.map((est, index) =>
                            <Estagiario
                                est={est}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarEstagiarios;